module.exports = __webpack_public_path__ + "img/team-8@2x-2.3865c090.png";